import moment from 'moment'
import i18n from 'i18n'

// Japanese customers expect yyyy/mm/dd dates; everyone else keeps the
// existing browser-locale toLocaleString() behavior so this doesn't change
// anything for the English UI.
export const formatDateTime = (value) => {
  if (value === null || value === undefined || value === '') return ''
  return i18n.language === 'jp'
    ? moment(value).format('YYYY/MM/DD HH:mm:ss')
    : new Date(value).toLocaleString()
}
